import { render, staticRenderFns } from "./OrdersTableContainer.vue?vue&type=template&id=9bd13234"
import script from "./OrdersTableContainer.vue?vue&type=script&lang=js"
export * from "./OrdersTableContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports